// extracted by mini-css-extract-plugin
export var chatHtmlText = "_o1-2";
export var chatLink = "_o1-0";
export var chatText = "_o1-1";